(() => {
  if (window.beatbotHeaderTrackingReady) return;
  window.beatbotHeaderTrackingReady = true;
  const selector = '[data-header-events]';
  const actions = new Set(['click', 'open', 'close', 'select', 'exposure']);
  const devices = new Set(['both', 'web', 'mobile']);
  const parsed = new Map();
  const scopes = new Map();
  const device = () => window.matchMedia('(max-width: 1280px)').matches ? 'mobile' : 'web';
  const configuration = source => {
    if (parsed.has(source)) return parsed.get(source);
    const events = {};
    source.split(/\r?\n/).map(line => line.trim()).filter(Boolean).forEach(line => {
      const separator = line.indexOf('=');
      if (separator === -1) { events.both = line; return; }
      const key = line.slice(0, separator).trim().toLowerCase();
      if (devices.has(key)) events[key] = line.slice(separator + 1).trim();
    });
    parsed.set(source, events);
    return events;
  };
  const eventName = (element, action) => {
    const defaultAction = element.dataset.headerEventAction || 'click';
    let source = '';
    if (action === 'click' && element.dataset.headerClickEvents) source = element.dataset.headerClickEvents;
    else if (action === 'exposure') source = element.dataset.headerExposureEvents || (defaultAction === 'exposure' ? element.dataset.headerEvents : '') || '';
    else if (defaultAction === 'toggle' && action === 'close') source = element.dataset.headerCloseEvents || '';
    else if (action === defaultAction || defaultAction === 'toggle' && action === 'open') source = element.dataset.headerEvents || '';
    const events = configuration(source);
    return events[device()] ?? events.both ?? '';
  };
  const parameters = (element, action) => {
    const link = element.matches('a[href]') ? element : element.querySelector('a[href]');
    return {
      terminal: device(),
      header_action: action,
      content_id: element.dataset.headerEventId || element.id || '',
      group_id: element.closest('[data-header-context]')?.dataset.headerContext || '',
      product_id: element.dataset.headerProductId || '',
      link_url: link?.href || '',
      entry_location: element.closest('[data-mobile-drawer]') ? 'mobile_drawer' : element.closest('.component-header__mobile-product-panel') ? 'mobile_panel' : element.closest('.bb-announcement') ? 'announcement' : device() === 'web' ? 'desktop_header' : 'mobile_header'
    };
  };
  const attribute = (element, name, value) => {
    if (value) {
      if (element.getAttribute(name) !== value) element.setAttribute(name, value);
    } else if (element.hasAttribute(name)) element.removeAttribute(name);
  };
  const synchronize = element => {
    const enabled = !window.Shopify?.designMode;
    const click = enabled ? eventName(element, 'click') : '';
    const exposure = enabled ? eventName(element, 'exposure') : '';
    attribute(element, 'event_name', click);
    attribute(element, 'exposure_event_name', exposure);
    attribute(element, 'event_params', click || exposure ? JSON.stringify(parameters(element, '')) : '');
  };
  const send = (element, action) => {
    if (window.Shopify?.designMode) return;
    const name = eventName(element, action);
    if (name && typeof window.beatbotTrackEvent === 'function') window.beatbotTrackEvent(name, parameters(element, action));
  };
  let frame = null;
  const scan = () => {
    frame = null;
    document.querySelectorAll(selector).forEach(synchronize);
    scopes.forEach((observer, scope) => {
      if (!scope.isConnected) { observer.disconnect(); scopes.delete(scope); }
    });
  };
  const schedule = () => { if (frame === null) frame = window.requestAnimationFrame(scan); };
  document.addEventListener('click', event => {
    const element = event.target.closest(selector);
    if (!element) return;
    synchronize(element);
    if (!event.isTrusted) return;
    const summary = event.target.closest('summary');
    if (summary === element && summary.parentElement.matches('details')) {
      const details = summary.parentElement;
      const wasOpen = details.open;
      window.setTimeout(() => {
        if (details.open !== wasOpen) send(element, details.open ? 'open' : 'close');
      }, 0);
    }
  }, true);
  document.addEventListener('header:track', event => {
    const { element, action } = event.detail || {};
    if (element?.matches(selector) && actions.has(action)) send(element, action);
  });
  window.addEventListener('resize', schedule, { passive: true });
  const initialize = () => {
    document.querySelectorAll('[data-header-tracking-scope]').forEach(scope => {
      if (scopes.has(scope)) return;
      const observer = new MutationObserver(schedule);
      observer.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-header-events', 'data-header-exposure-events', 'data-header-close-events', 'data-header-click-events', 'data-header-event-action'] });
      scopes.set(scope, observer);
    });
    scan();
  };
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
